import { render, staticRenderFns } from "./InformasiLainnyaDetail-Mobile.vue?vue&type=template&id=5624d0fc&scoped=true&"
import script from "./InformasiLainnyaDetail-Mobile.vue?vue&type=script&lang=js&"
export * from "./InformasiLainnyaDetail-Mobile.vue?vue&type=script&lang=js&"
import style0 from "./InformasiLainnyaDetail-Mobile.vue?vue&type=style&index=0&id=5624d0fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624d0fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VLayout})
